import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {StyledNotificationItem} from './style'

export const NotificationSkeletonItem = () => {
    return (
        <StyledNotificationItem direction="row" align="start" justify="space-between" fullWidth gap={4}>
            <Flexbox direction="column" align="start" gap={2}>
                <Flexbox direction="row" align="start" gap={4}>
                    <Flexbox direction="row" align="center" gap={2}>
                        <Skeleton width={40} height={40} style={{borderRadius: '50%'}} />
                        <Skeleton width={120} height={16} />
                    </Flexbox>
                    <Flexbox direction="column" gap={1}>
                        <Skeleton width={200} height={20} />
                        <Skeleton width={280} height={16} />
                    </Flexbox>
                </Flexbox>
            </Flexbox>
            <Skeleton width={80} height={14} />
        </StyledNotificationItem>
    )
}

const NotificationSkeletonComponent = () => {
    return (
        <Flexbox direction="column" gap={2}>
            {Array.from({length: 3}).map((_, index) => (
                <NotificationSkeletonItem key={index} />
            ))}
        </Flexbox>
    )
}

export const NotificationSkeleton = NotificationSkeletonComponent
